import initSlider from 'utils/slider';
import { RECIRCULATION_SLIDER } from 'constants/settings';

class Recirculation {
  constructor() {
    this.gallery = [].slice.call(document.getElementsByClassName('recirculation-slider'));

    //Initialize recirculaion slider
    this.gallery.map((g, i) => initSlider(g, RECIRCULATION_SLIDER));
  }
}

export default Recirculation;



// WEBPACK FOOTER //
// ./app/javascript/global/recirculation.js